import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7007Model } from '../kymw7007.model';
import { MediumType } from '../vo/medium-type.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetOrderCodeMediumListResponse = {
  MediumType: string;
  MediumName: string;
}[];

/**
 * 受注コード媒体リスト取得サービス
 * @export GetOrderCodeMediumListService
 * @class GetOrderCodeMediumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderCodeMediumListService extends PlessJsonResponderSub<GetOrderCodeMediumListResponse> {
  model: KYMW7007Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderCodeMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOrderCodeMediumListService
   */
  execute(model: KYMW7007Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getOrderCodeMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderCodeMediumListService
   */
  success(data: GetOrderCodeMediumListResponse) {
    this.model.mediumTypeList = data.map(_ => new MediumType(
      _.MediumType,
      _.MediumName,
    ));
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
